<div class="container">
    <mat-paginator
    #paginatorPage
    [length]="length"
    [pageIndex]="currentPage" 
    [pageSize]="pageSize" 
    [pageSizeOptions]="[5, 10, 25, 100]"
    showFirstLastButtons aria-label="Select page"
    (page)="changePage($event)">
    </mat-paginator>
</div>